"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatIdeationColumnHeader = exports.default = exports.SKELETON_COUNT = exports.IdeationColumnShell = void 0;

var _preact = require("preact");

var _Skeleton = require("@insided/shared/uikit/Skeleton");

var _ideaCard = require("./ideaCard");

var _IdeaCardSkeleton = require("./IdeaCardSkeleton");

var _IdeaCardTitle = require("./IdeaCardTitle");

var _formatCount = require("@insided/shared/utils/formatCount");

var _IdeaCardAuthor = _interopRequireDefault(require("./IdeaCardAuthor"));

var _IdeaCardVote = require("./IdeaCardVote");

var headerHeight = 56;
var SKELETON_COUNT = 3;
exports.SKELETON_COUNT = SKELETON_COUNT;
var ANONYMOUS_AUTHOR = {
  id: '0',
  name: 'Anonymous',
  avatar: ''
};

var getAuthorForIdea = function getAuthorForIdea(idea, authors) {
  var _idea$author;

  var authorId = (_idea$author = idea.author) === null || _idea$author === void 0 ? void 0 : _idea$author.id;

  if (!authorId) {
    return ANONYMOUS_AUTHOR;
  }

  var freshAuthor = authors[authorId];

  if (freshAuthor) {
    return freshAuthor;
  }

  if (idea.author.username) {
    return {
      id: idea.author.id,
      name: idea.author.username,
      avatar: idea.author.avatar || ''
    };
  }

  return ANONYMOUS_AUTHOR;
};

/**
 * Pure shell component for IdeationColumn structure.
 * Accepts header and list content as slots.
 */
var IdeationColumnShell = function IdeationColumnShell(props) {
  var header = props.header,
      list = props.list,
      maxHeight = props.maxHeight,
      HeaderTag = props.HeaderTag;

  var getWrapperStyles = function getWrapperStyles() {
    return {
      maxHeight: maxHeight - headerHeight,
      overflowY: 'scroll'
    };
  };

  return (0, _preact.h)("div", {
    className: "pipeline__column-wrapper"
  }, (0, _preact.h)("div", {
    className: "pipeline__column-header"
  }, (0, _preact.h)(HeaderTag, {
    className: "h5 pipeline__column-title"
  }, header)), (0, _preact.h)("div", {
    className: "pipeline__ideation-list-wrapper",
    style: getWrapperStyles()
  }, list));
};
/**
 * Helper function to format the header text with title and count.
 * Returns a simple string, no extra HTML.
 */


exports.IdeationColumnShell = IdeationColumnShell;

var formatIdeationColumnHeader = function formatIdeationColumnHeader(title, count) {
  if (count <= 0) return title;
  return "".concat(title, " (").concat((0, _formatCount.formatCount)(count), ")");
};

exports.formatIdeationColumnHeader = formatIdeationColumnHeader;

/**
 * Smart IdeationColumn component with guardian clauses.
 * Handles loading and empty states with early returns.
 */
var IdeationColumn = function IdeationColumn(props) {
  var columnData = props.columnData,
      statusTitle = props.statusTitle,
      maxHeight = props.maxHeight,
      HeaderTag = props.HeaderTag,
      isLoading = props.isLoading;
  var topics = columnData.topics,
      totalTopicCount = columnData.totalTopicCount,
      authors = columnData.authors; // Guardian: Empty state when not loading

  if (!isLoading && topics.length === 0) {
    return null;
  } // Guardian: Loading state


  if (isLoading) {
    return (0, _preact.h)(IdeationColumnShell, {
      HeaderTag: HeaderTag,
      header: (0, _preact.h)(_Skeleton.TextSkeleton, {
        width: "12em"
      }),
      list: Array.from({
        length: SKELETON_COUNT
      }).map(function (_, index) {
        return (0, _preact.h)(_ideaCard.IdeaCard, {
          key: "skeleton-".concat(index),
          title: (0, _preact.h)(_IdeaCardSkeleton.IdeaCardTitleSkeleton, null),
          meta: (0, _preact.h)(_IdeaCardSkeleton.IdeaCardMetaSkeleton, null)
        });
      }),
      maxHeight: maxHeight
    });
  } // Default: Data state


  return (0, _preact.h)(IdeationColumnShell, {
    HeaderTag: HeaderTag,
    header: formatIdeationColumnHeader(statusTitle, totalTopicCount),
    list: topics.map(function (idea) {
      return (0, _preact.h)(_ideaCard.IdeaCard, {
        key: idea.id,
        title: (0, _preact.h)(_IdeaCardTitle.IdeaCardTitle, {
          title: idea.title,
          publicId: idea.publicId
        }),
        meta: [(0, _preact.h)(_IdeaCardAuthor.default, {
          key: "author",
          author: getAuthorForIdea(idea, authors)
        }), (0, _preact.h)(_IdeaCardVote.IdeaCardVote, {
          key: "vote",
          ideaId: idea.id,
          votes: idea.votes,
          likedOrVotedByCurrentUser: idea.likedOrVotedByCurrentUser
        })]
      });
    }),
    maxHeight: maxHeight
  });
};

var _default = IdeationColumn;
exports.default = _default;